import { Directive } from '@angular/core';

@Directive({
	selector: '[auiFooterContent]',
})
export class FooterContentDirective {}
